
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() model!: any;
  @Prop() title!: string;
  getClass(item: any) {
    let className = 'keyboard';

    if (item) {
      let name = '';
      if (item.command) {
        /* 键盘 */
        name = item.command == '' ? item.command_arr[0] : item.command;
      } else {
        /* 手柄 */
        name = item.command_arr[0];
      }

      switch (name) {
        case 'LT':
          className = 'keyboard-lt';
          break;
        case 'LB':
          className = 'keyboard-lb';
          break;
        case 'RB':
          className = 'keyboard-rb';
          break;
        case 'RT':
          className = 'keyboard-rt';
          break;
        case 'up':
          className = 'keyboard-up';
          break;
        case 'down':
          className = 'keyboard-down';
          break;
        case 'hold':
          className = 'keyboard-down';
          break;
        case 'left':
          className = 'keyboard-left';
          break;
        case 'right':
          className = 'keyboard-right';
          break;
        default:
          className = 'keyboard';
          break;
      }
    }
    if (item.text.length > 3) {
      className += ' font10';
    }
    return className;
  }
}
